import * as React from 'react'
import { FC } from 'react'
import { Theme, useTheme } from '@mui/material/styles'

import { useGetServiceLocationUrl } from '@user/store/authorization/hooks'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

interface Props {
  locationId: string
  locationCode: string
}

const getStyles = (theme: Theme) => ({
  arrow: {
    marginBottom: theme.spacing(0.4),
    marginLeft: theme.spacing(0.6),
    verticalAlign: 'middle',
  },

  link: {
    color: '#005aa3',
    textDecoration: 'none',
  },
})

export const DraftLeadLocationTag: FC<Props> = (props) => {
  const { locationId, locationCode } = props

  const locationUrl = useGetServiceLocationUrl(locationId)
  const styles = getStyles(useTheme())
  return (
    <Box display="flex" alignItems="center">
      {!!locationId && (
        <Typography component="div">
          Location:{' '}
          <Link
            href={locationUrl}
            target="_blank"
            rel="noreferrer"
            sx={styles.link}
            underline="none"
            data-test-id={`draft-lead-location-${locationId}`}
          >
            {locationCode}
            <img
              style={styles.arrow}
              src="/static-assets/icons/arrow-northeast.svg"
            />
          </Link>
        </Typography>
      )}
    </Box>
  )
}

DraftLeadLocationTag.displayName = 'DraftLeadLocationTag'
